import React, { Component } from 'react';
import { HashRouter, Route } from 'react-router-dom';
import classNames from 'classnames';
import './App.css';

import Welcome from './pages/Welcome';
import Info from './pages/Info';
import Estimate from './pages/Estimate';
import Contacts from './pages/Contacts';
import Uploader from './pages/Uploader';
import Finished from './pages/Finished';

import FooterNav from './components/FooterNav';

import state from './services/state';

class App extends Component {
	render() {
		const classes = classNames({
			'fresh-uploader-app': true,
			dev: window.location.hostname === 'localhost'
		});
		return (
			<div className={classes} id="fresh-uploader-app">
				<HashRouter>
					<div>
						<div className="router-wrapper">
							<Route exact path="/" component={Welcome} />
							<Route exact path="/info" component={Info} />
							<Route
								exact
								path="/estimate"
								component={Estimate}
							/>
							<Route
								exact
								path="/contacts"
								component={Contacts}
							/>
							<Route exact path="/upload" component={Uploader} />
							<Route
								exact
								path="/finished"
								component={Finished}
							/>
						</div>
						<FooterNav />
					</div>
				</HashRouter>
			</div>
		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js